module.exports = __webpack_public_path__ + "img/play-btn.6d39675a.svg";